const initialState = {
  users: [],
  createModalActive: false,
  createFormState: {
    data: {},
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_USERS': {
      const { users } = payload;
      return {
        ...state,
        users,
      };
    }
    case 'TOGGLE_MODAL': {
      const { active } = payload;
      return {
        ...state,
        createModalActive: active,
        createFormState: initialState.createFormState,
      };
    }
    case 'ON_CREATE_FORM_UPDATE': {
      const { formState } = payload;
      return {
        ...state,
        createFormState: formState,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Users/Users.reducer.js